import type { MatchUser, KarteUser, Sex } from '@/types/app'

import { Prefecture, UserGender } from '@/types/schema.generated'
import { prefectureLabel } from '@/features/prefecture/prefecture'

const sexMap: Record<Sex, string> = {
  male: '男',
  female: '女',
  noAnswer: '無回答',
}

export const convertUserGenderToSex = (gender: UserGender): Sex => {
  switch (gender) {
    case 'MALE':
      return 'male'
    case 'FEMALE':
      return 'female'
    case 'NO_ANSWER':
      return 'noAnswer'
    case 'OTHER':
      // OTHER -> noAnswer への不適切な変換だが、Sex 型に OTHER 相当がないためこうしている
      // User の診断として性別は 男女しか扱っていないので、ここはこれでも問題はない
      return 'noAnswer'
  }
}

export const formatUserProfile = (user: MatchUser | KarteUser): string => {
  if (user.diagnosisResult === undefined) {
    return '未診断'
  }

  const address = (() => {
    if (user.address) {
      // prefecture がなく、city があるケースは存在しない
      return [user.address.prefecture, user.address.city]
        .filter(Boolean)
        .join(' ')
    } else if (user.livingPrefecture) {
      return prefectureLabel(user.livingPrefecture as Prefecture)
    }
  })()

  const age = (() => {
    if (user.yearOfBirth) {
      return `${new Date().getFullYear() - user.yearOfBirth}歳`
    } else {
      return undefined
    }
  })()

  const sexString = (() => {
    if (user.sex == 'male' || user.sex == 'female') {
      return `${sexMap[user.sex]}性`
    }
  })()

  return [address, age, sexString]
    .filter(
      (profile: Maybe<string | undefined | null>) => profile !== undefined
    )
    .join('・')
}
